import {
  FETCH_PASS_VIEW_SUCCESS,
  FETCH_PASS_VIEW_FAILURE,
  FETCH_ZONE_VIEW_SUCCESS,
  FETCH_ZONE_VIEW_FAILURE,
  FETCH_TILT_VIEW_SUCCESS,
  FETCH_TILT_VIEW_FAILURE,
  SET_PASS_VIEW_LOADING,
  SET_ZONE_VIEW_LOADING,
  SET_TILT_VIEW_LOADING,
} from "./types";

const initialState = {
  passView: null,
  zoneView: null,
  tiltView: null,
  passViewError: null,
  zoneViewError: null,
  tiltViewError: null,
  isLoading: {
    passView: false,
    zoneView: false,
    tiltView: false,
  },
};

const d360LiveViewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PASS_VIEW_LOADING:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          passView: action.payload,
        },
      };
    case SET_ZONE_VIEW_LOADING:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          zoneView: action.payload,
        },
      };
    case SET_TILT_VIEW_LOADING:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          tiltView: action.payload,
        },
      };
    case FETCH_PASS_VIEW_SUCCESS:
      return {
        ...state,
        passView: action.payload,
        passViewError: null,
        isLoading: {
          ...state.isLoading,
          passView: false,
        },
      };
    case FETCH_PASS_VIEW_FAILURE:
      return {
        ...state,
        passViewError: action.payload,
        isLoading: {
          ...state.isLoading,
          passView: false,
        },
      };
    case FETCH_ZONE_VIEW_SUCCESS:
      return {
        ...state,
        zoneView: action.payload,
        zoneViewError: null,
        isLoading: {
          ...state.isLoading,
          zoneView: false,
        },
      };
    case FETCH_ZONE_VIEW_FAILURE:
      return {
        ...state,
        zoneViewError: action.payload,
        isLoading: {
          ...state.isLoading,
          zoneView: false,
        },
      };
    case FETCH_TILT_VIEW_SUCCESS:
      return {
        ...state,
        tiltView: action.payload,
        tiltViewError: null,
        isLoading: {
          ...state.isLoading,
          tiltView: false,
        },
      };
    case FETCH_TILT_VIEW_FAILURE:
      return {
        ...state,
        tiltViewError: action.payload,
        isLoading: {
          ...state.isLoading,
          tiltView: false,
        },
      };
    default:
      return state;
  }
};

export default d360LiveViewsReducer;
